import type { RunStatus } from "../features/ops/investigationProjection";

/** The same terminal outcome has the same meaning on every investigation surface. */
export function runStatusTone(status: string): "good" | "bad" | "warn" {
  if (status === "complete") return "good";
  if (status === "failed" || status === "budget_exhausted") return "bad";
  return "warn";
}

/** A readable UTC timestamp, including seconds; the source remains available on time elements. */
export function readableTime(value: string | null): string {
  if (!value) return "Unknown";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    dateStyle: "medium", timeStyle: "medium", timeZone: "UTC",
  }) + " UTC";
}

/**
 * Every run status as a person reads it (#798): the store's words are codes, and a chip
 * that says `budget_exhausted` is a code shown to a person. Typed over `RunStatus`, so a
 * status added there without a label here does not compile.
 */
export const RUN_STATUS_LABEL: Record<RunStatus, string> = {
  running: "Running",
  paused: "Paused",
  complete: "Complete",
  failed: "Failed",
  budget_exhausted: "Budget exhausted",
};

/**
 * A run status in words. A status this console does not know yet (the list reads
 * `unknown` for a row with none, and the run page `waiting` before its first event) is
 * still shown as words, never with its underscores.
 */
export function runStatusLabel(status: string): string {
  if (Object.prototype.hasOwnProperty.call(RUN_STATUS_LABEL, status)) return RUN_STATUS_LABEL[status as RunStatus];
  const readable = status.replace(/_/g, " ").trim();
  return readable === "" ? "Unknown" : readable.charAt(0).toUpperCase() + readable.slice(1);
}
